import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { tap, map, Observable } from 'rxjs';

import { CookiesService } from './cookies.service';

@Injectable({
  providedIn: 'root'
})
export class BaseAuthService {

  constructor(
    private cookiesService: CookiesService,
    private auth0: AuthService
  ) { }

  monitorAuthenticationStatus(): void {
    this.auth0.idTokenClaims$.pipe(
      tap((response) => {
        if (response?.exp) {
          this.checkAndRenewToken(response.exp);
        }
      })
    ).subscribe();
  }

  checkAndRenewToken(expiryTimestamp: number): void {
    const isTokenExpired: boolean = this.isTokenExpired(expiryTimestamp);

    if (isTokenExpired) {
      this.auth0.logout();
    }
  }

  private isTokenExpired(expirationTime: number): boolean {
    const decodedToken: number = expirationTime
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken < currentTime;
  }
  
  getCurrentUserEmail(): Observable<string> {
    return this.auth0.user$.pipe(
      map((user) => {
        return user?.email || '';
      })
    );
  }
}
